var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{
    'button-override q-mt-sm text-weight-bold items-center flex': true,
    'text-secondary cursor-pointer': !_vm.disabled,
    'text-grey-6': _vm.disabled
  },attrs:{"disabled":_vm.disabled,"type":"submit"}},[_c('QIcon',{staticClass:"q-mr-sm",attrs:{"name":_vm.plusIcon,"size":"xs"}}),_c('span',{staticClass:"q-ma-none text-body3"},[_vm._v("ADD "+_vm._s(_vm.suffix))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }